import { EMAIL_REGEX, sanitizeNationalPhone } from "../utils/formValidation";

export const USER_SEARCH_TYPES = {
  EMAIL: "email",
  MOBILE: "mobile",
  USER_ID: "userId",
  USERNAME: "username",
};

/** UUID-style / dashed alphanumeric id (e.g. cfb7ccdd-e521-4a18-95ee-89d706f72744). */
const USER_ID_WITH_DASH_REGEX =
  /^[a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)+$/;

/**
 * Strip country/ISD prefixes and keep the national 10-digit mobile only.
 * Accepts values like 8050132145, +918050132145, 918050132145, 08050132145.
 */
export const toNationalMobile = (rawValue = "") => {
  const digits = sanitizeNationalPhone(rawValue);
  const rawDigits = String(rawValue || "").replace(/\D/g, "");
  const candidate =
    digits ||
    (rawDigits.length >= 10 ? rawDigits.slice(-10) : rawDigits);
  return /^[6-9]\d{9}$/.test(candidate) ? candidate : "";
};

/**
 * Detect search type from a single intelligent search input.
 * Mobile search always uses the 10-digit national number (no country code).
 */
export const detectUserSearchType = (rawValue = "") => {
  const value = String(rawValue || "").trim();
  if (!value) return null;

  if (EMAIL_REGEX.test(value)) {
    return { type: USER_SEARCH_TYPES.EMAIL, value, queryValue: value };
  }

  const nationalMobile = toNationalMobile(value);
  if (nationalMobile) {
    return {
      type: USER_SEARCH_TYPES.MOBILE,
      value: nationalMobile,
      queryValue: nationalMobile,
    };
  }

  if (USER_ID_WITH_DASH_REGEX.test(value) && value.includes("-")) {
    return { type: USER_SEARCH_TYPES.USER_ID, value, queryValue: value };
  }

  return { type: USER_SEARCH_TYPES.USERNAME, value, queryValue: value };
};

export const getUserSearchTypeLabel = (type) => {
  switch (type) {
    case USER_SEARCH_TYPES.EMAIL:
      return "Email";
    case USER_SEARCH_TYPES.MOBILE:
      return "Mobile";
    case USER_SEARCH_TYPES.USER_ID:
      return "User ID";
    case USER_SEARCH_TYPES.USERNAME:
      return "User Name";
    default:
      return "Search";
  }
};
